module.exports = "\n<div style=\"height:100px\"></div>\n<app-produktuebersicht></app-produktuebersicht>\n<app-CTA></app-CTA>"